import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'

export default function useNbTails(deviceId?: string) {
  const nbTailsQuery = useQuery({
    queryKey: ['nb-tails', deviceId],
    queryFn: () => dataAPI.getNBTails(deviceId || ''),
    enabled: !!deviceId, // Only run query if deviceId is provided
  })

  return {
    nbTailsQuery: {
      data: nbTailsQuery.data,
      isLoading: nbTailsQuery.isLoading,
      isSuccess: nbTailsQuery.isSuccess,
      isError: nbTailsQuery.isError,
      error: nbTailsQuery.error,
      refetch: nbTailsQuery.refetch,
      isRefetching: nbTailsQuery.isRefetching
    }
  }
}

